var _defs, _g, _g2, _path, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsMIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2282",
    "data-name": "Group 2282",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.401,
    height: 34.797,
    viewBox: "0 0 57.401 34.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M343.085,91.539l0,1.575c6.11-3.382,15.8-3.332,21.843.155,3.084,1.781,4.624,4.116,4.617,6.447l0-1.575c.007-2.331-1.533-4.666-4.617-6.447a24.441,24.441,0,0,0-21.843-.155",
    transform: "translate(-343.081 -89.04)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M808.329,245.713l0,1.575c4.7-2.812,7.053-6.452,7.063-10.1l0-1.575c-.01,3.646-2.364,7.286-7.063,10.1",
    transform: "translate(-808.325 -235.615)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 57.401,
    height: 34.797,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(21.363 5.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M364.929,91.694a17.013,17.013,0,0,0-2.258-1.083c-.612-.241-1.246-.455-1.9-.641q-.8-.228-1.634-.4-.765-.159-1.551-.27-.753-.107-1.518-.169t-1.539-.082q-.8-.02-1.6.007-.874.03-1.74.116c-.673.067-1.341.16-2,.278a22.682,22.682,0,0,0-2.931.728,17.981,17.981,0,0,0-3.181,1.361l0,1.575a17.981,17.981,0,0,1,3.181-1.361,22.667,22.667,0,0,1,2.931-.728c.656-.118,1.323-.211,2-.278q.865-.086,1.741-.116.8-.027,1.6-.007.772.019,1.539.082t1.518.17q.784.111,1.551.27.832.172,1.634.4c.652.186,1.286.4,1.9.641a17.017,17.017,0,0,1,2.258,1.083c3.084,1.781,4.624,4.116,4.617,6.447l0-1.575c.007-2.331-1.533-4.666-4.617-6.447",
    transform: "translate(-343.081 -89.04)",
    fill: "#d1365a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(50.334 14.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M921.7,235.615l0,1.575q0,.11,0,.221l0-1.575q0-.11,0-.221",
    transform: "translate(-914.634 -235.615)",
    fill: "#94344a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M816.513,240.6a9.157,9.157,0,0,1-.407,1.418,10.221,10.221,0,0,1-.673,1.436,11.885,11.885,0,0,1-1.012,1.5,14.533,14.533,0,0,1-1.571,1.688,19.505,19.505,0,0,1-3.146,2.335l0,1.575a19.507,19.507,0,0,0,3.146-2.335,14.528,14.528,0,0,0,1.571-1.688,11.883,11.883,0,0,0,1.011-1.5,10.2,10.2,0,0,0,.673-1.436,9.162,9.162,0,0,0,.407-1.418,8.628,8.628,0,0,0,.165-1.447l0-1.575a8.609,8.609,0,0,1-.165,1.447",
    transform: "translate(-809.614 -238.937)",
    fill: "#d1365a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M808.414,396.954l0,1.575-.086.051,0-1.575.086-.051",
    transform: "translate(-808.324 -386.908)",
    fill: "#b8405b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M0,114.689l45.342,26.178,0-1.575L0,113.113Z",
    transform: "translate(0 -106.07)",
    fill: "#893044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M728.164,447.9l0,1.575,9.784-5.686,0-1.575Z",
    transform: "translate(-682.817 -414.674)",
    fill: "#d1365a"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M50.406,24.769,55.2,27.535l-9.784,5.686L.072,7.043,9.856,1.357l4.789,2.765c9.834-5.546,25.591-5.5,35.382.154s9.923,14.78.378,20.493M21.435,8.043l22.18,12.806c5.819-3.55,5.7-9.163-.337-12.65S27.545,4.661,21.435,8.043",
    transform: "translate(-0.068 0.001)",
    fill: "#ff597f"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M0,87.842l45.339,26.177,2.834-1.647L2.834,86.2Z",
    transform: "translate(0 -80.828)",
    fill: "#ff7d9b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M149.7,137.96l-6.2,3.6-1.4-.806,6.2-3.6Z",
    transform: "translate(-133.262 -128.613)",
    fill: "#644daa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M441.346,306.339l-6.2,3.6-1.394-.8,6.2-3.6Z",
    transform: "translate(-406.745 -286.509)",
    fill: "#644daa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M208.068,171.656l-6.2,3.6-1.392-.8,6.2-3.6Z",
    transform: "translate(-187.996 -160.213)",
    fill: "#644daa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M266.4,205.332l-6.2,3.6-1.392-.8,6.2-3.6Z",
    transform: "translate(-242.692 -191.793)",
    fill: "#644daa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M324.688,238.987l-6.2,3.6-1.394-.8,6.2-3.6Z",
    transform: "translate(-297.351 -223.35)",
    fill: "#644daa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M91.412,104.3l-6.2,3.6-1.394-.8,6.2-3.6Z",
    transform: "translate(-78.601 -97.055)",
    fill: "#644daa"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M33.081,70.627l-6.2,3.6-1.392-.8,6.2-3.6Z",
    transform: "translate(-23.905 -65.475)",
    fill: "#644daa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M383.019,272.664l-6.2,3.6-1.4-.806,6.2-3.6Z",
    transform: "translate(-352.048 -254.929)",
    fill: "#644daa"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M499.712,340.036l-6.2,3.6-1.392-.8,6.2-3.6Z",
    transform: "translate(-461.479 -318.109)",
    fill: "#644daa"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M674.661,441.044l-6.2,3.6-1.394-.8,6.2-3.6Z",
    transform: "translate(-625.532 -412.826)",
    fill: "#644daa"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M558,373.691l-6.2,3.6-1.394-.8,6.2-3.6Z",
    transform: "translate(-516.139 -349.667)",
    fill: "#644daa"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M616.329,407.366l-6.2,3.6-1.392-.8,6.2-3.6Z",
    transform: "translate(-570.835 -381.246)",
    fill: "#644daa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsMIcon2);
export default __webpack_public_path__ + "static/media/maths-m-icon-2.0fab0bf09dcc640609e25ee3168fefb5.svg";
export { ForwardRef as ReactComponent };